import { INDUSTRIES } from "../lib/data";

export default function IndustriesGrid({ compact = false }) {
  return (
    <section data-testid="industries-grid" className="py-24 lg:py-32 bg-[#F4F7FA] relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <div className="kicker">Sectors</div>
            <h2 className="mt-3 font-heading text-4xl sm:text-5xl font-black text-navy tracking-tight">
              Industries we serve.
            </h2>
          </div>
          {!compact && (
            <p className="lg:col-span-5 text-lg text-slate-600">
              Specialized safety expertise across high-risk operational environments —
              tailored to the regulations and realities of each sector.
            </p>
          )}
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {INDUSTRIES.map((ind, i) => {
            const Icon = ind.icon;
            return (
              <div
                key={ind.name}
                data-testid={`industry-card-${i}`}
                className="card-hover group bg-white border border-navy/10 rounded-xl p-6 flex flex-col items-center text-center"
              >
                <div className="h-16 w-16 rounded-full bg-steel-light flex items-center justify-center text-navy group-hover:bg-safety group-hover:text-white transition-colors">
                  <Icon className="h-8 w-8" />
                </div>
                <div className="mt-4 font-heading font-bold text-navy text-base">{ind.name}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
